import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    .", ", .", " {\n        opacity: 0;\n        transition: opacity ", "s ease;\n    }\n    &:hover {\n        .", ", .", " {\n            opacity: 1;\n        }\n    }\n\n    ", ";\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            cursor: pointer;\n            user-select: none;\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { paddingAttributes } from '../../../system/attributes';
import { makeBEM, makePropList, getPropsBlocker } from '../../../utils';
import { TableCell } from '../TableCell';
import { transitionDurationInSec } from '../../../constants';
import { TABLE_HEAD_CELL_CLASS_PREFIX } from './constants';
var propertyList = makePropList(['sortingEnabled', 'sortable', 'columnId', 'rowSortType']);

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var theme = _ref.theme,
      sortingEnabled = _ref.sortingEnabled;
  var TableHeadCell = theme.componentOverrides.TableHeadCell;
  var result = TableHeadCell.Root.base;

  if (sortingEnabled) {
    result = css(_templateObject(), result);
  }

  return result;
};

var alphabeticalIconClassName = makeBEM(TABLE_HEAD_CELL_CLASS_PREFIX, 'AlphabeticalIcon');
var numericalIconClassName = makeBEM(TABLE_HEAD_CELL_CLASS_PREFIX, 'NumericalIcon');
export var TableHeadCellRoot = styled(TableCell).withConfig(getPropsBlocker(propertyList, false))(_templateObject2(), alphabeticalIconClassName, numericalIconClassName, transitionDurationInSec, alphabeticalIconClassName, numericalIconClassName, getRootDynamicStyle, paddingAttributes);